import { IonAvatar, IonBadge, IonIcon, IonItem, IonLabel } from "@ionic/react";
import { beerSharp, walkOutline } from "ionicons/icons";
import moment from "moment";
import ProfitIndicator from "./ProfitIndicator";
import { useAuthStore } from "../stores/auth.store";
import { useBotsStore } from "../stores/bots.store";
import { getCoinName } from "../utils/getCoinName";
import getCoinImage from "../utils/getCoinImage";
import { useHistory } from "react-router-dom";
interface Props {
  trade: any;
  botId?: string;
  navigate?: boolean;
}

const TradeListItem: React.FC<Props> = ({ trade, botId, navigate }) => {
  const uid = useAuthStore(state => state.user?.uid);
  const bot = useBotsStore(state => state.bots.find(bot => bot.id === botId));
  const history = useHistory();

  const botData = bot?.data;

  const actions = botData?.actions
    ? Object.keys(botData?.actions).map(key => ({
        ...botData?.actions[key],
        id: key
      }))
    : [];

  const isManualBuy = actions?.find(
    (action: {
      action: string;
      botId: string;
      status: string;
      payload: { tradeId: any };
    }) =>
      action?.action === "manualBuy" &&
      action?.payload?.tradeId === trade?.id &&
      action?.status === "completed"
  );

  const isManualSell = actions?.find(
    (action: {
      action: string;
      botId: string;
      status: string;
      payload: { tradeId: any };
    }) =>
      action?.action === "closeTrade" &&
      action?.payload?.tradeId === trade?.id &&
      action?.status === "completed"
  );

  const coin =
    trade?.coinPair?.replace("USDT", "") || trade?.symbol?.replace("/USDT", "");
  const buyDate = moment(
    bot?.mode === "live"
      ? trade?.buy?.dateClosed
      : trade?.buy?.dateClosed * 1000
  ).format("DD/MM/YYYY HH:mm");
  const highDate = moment(trade?.stats?.highTimestamp * 1000).format(
    "DD/MM/YYYY HH:mm"
  );
  const lowDate = moment(trade?.stats?.lowTimestamp * 1000).format(
    "DD/MM/YYYY HH:mm"
  );
  const sellDate = moment(
    bot?.mode === "live"
      ? trade?.sell?.dateClosed
      : trade?.sell?.dateClosed * 1000
  ).format("DD/MM/YYYY HH:mm");

  const canSell =
    (botId &&
      uid === bot?.user &&
      bot?.active &&
      !trade?.sell &&
      trade?.type !== "topup") ||
    false;
  const coinName = getCoinName(coin);
  return (
    <IonItem
      detail={false}
      button={navigate && canSell}
      onClick={() => {
        if (navigate && canSell) {
          history.push(`/bots/${botId}/trades/${trade?.id}`);
        }
      }}
    >
      <IonAvatar slot="start" className="shadow relative">
        <img src={getCoinImage(coin?.toLowerCase())} alt={coin} />
      </IonAvatar>
      {trade?.type === "topup" && (
        <IonBadge className="flex items-center absolute right-2 top-4">
          <IonIcon icon={beerSharp} />
          TopUp
        </IonBadge>
      )}
      {trade?.type !== "topup" && (
        <div className="flex items-center absolute right-2 top-2">
          <ProfitIndicator profit={trade?.stats?.profitMargin} />
        </div>
      )}
      <IonLabel>
        <div>
          <span className="font-bold text-lg">
            {trade?.buy?.origQty?.toFixed(4)} {coin}
          </span>
          {coinName && (
            <span className="text-sm text-gray-500"> ~ {coinName} </span>
          )}
        </div>
        <div className="flex justify-between pt-2">
          <span>
            {isManualBuy && (
              <IonIcon icon={walkOutline} className="text-white" />
            )}
            <span className="text-sm font-bold">BUY</span>
            <span className="text-xs pl-4 items-left">
              {trade?.buy?.price?.toFixed(2)} USDT
            </span>
          </span>
          <span className="text-primary-60 text-xs">@ {buyDate}</span>
        </div>
        {trade?.stats && (
          <div className="flex justify-between">
            <span>
              <span className="text-xs text-slate-200 font-semibold">MAX</span>
              <span
                className={`${
                  trade?.stats?.high > 0 ? "text-green-500" : "text-red-500"
                } text-xs pl-4`}
              >
                {trade?.stats?.high?.toFixed(2)} %
              </span>
            </span>
            <span className="text-primary-60 text-xs">@ {highDate}</span>
          </div>
        )}
        {trade?.stats && (
          <div className="flex justify-between">
            <span>
              <span className="text-xs text-slate-200 font-bold">MIN</span>
              <span
                className={`${
                  trade?.stats?.low > 0 ? "text-green-500" : "text-red-500"
                } text-xs pl-4`}
              >
                {trade?.stats?.low?.toFixed(2)} %
              </span>
            </span>
            <span className="text-primary-60 text-xs">@ {lowDate}</span>
          </div>
        )}
        {trade?.sell && (
          <div className="flex justify-between">
            <span>
              {isManualSell && (
                <IonIcon icon={walkOutline} className="text-white" />
              )}
              <span className="text-sm font-bold">SELL</span>
              <span className="text-xs pl-4">
                {trade?.sell?.price?.toFixed(2)} USDT
              </span>
            </span>
            <span className="text-primary-60 text-xs">@ {sellDate}</span>
          </div>
        )}
      </IonLabel>
    </IonItem>
  );
};

export default TradeListItem;
